import { Button, ButtonType, Form, Radio, SubmitButton, Switch, Tooltip } from '@digicert/dcone-common-ui'
import React, { useEffect, useState } from 'react'
import { ExtendedTwoFactorAuthProps, IVerificationType } from './TwoFactorAuth.types'
import { Translate } from 'react-localize-redux'
import styles from './TwoFactorAuth.module.scss'
import { enableMfa } from 'secure-pages/tenants/Tenants.actions'
import { connect } from 'react-redux'
import { translate } from 'shared/helpers/utils'
import { isEqual } from 'lodash'

const TwoFactorAuthentication = ({ onCancel, account, enableMfa, updateDetails }: ExtendedTwoFactorAuthProps) => {
  const emailAuthTypes = ['otp', 'email_otp']
  const cacTypes = ['cac']
  const [enable2FA, setEnable2FA] = useState(account.mfa_enabled)
  const [verificationType, setVerificationType] = useState(isEqual(account.mfa_types, cacTypes) ? IVerificationType.CAC : IVerificationType.EMAIL_AUTHENTICATOR_APP)
  const [cacDisabled, setCacDisabled] = useState(account?.sign_in_methods.find(item => item.signInMethod === 'standard')?.clientAuthCertLoginEnabled === true)

  const getMfaTypes = () => {
    switch (verificationType) {
      case IVerificationType.EMAIL_AUTHENTICATOR_APP:
        return emailAuthTypes
      case IVerificationType.CAC:
        return cacTypes
    }
  }

  const resetData = () => {
    setEnable2FA(account.mfa_enabled)
    setVerificationType(isEqual(account.mfa_types, cacTypes) ? IVerificationType.CAC : IVerificationType.EMAIL_AUTHENTICATOR_APP)
  }

  useEffect(() => {
    setCacDisabled(account?.sign_in_methods.find(item => item.signInMethod === 'standard')?.clientAuthCertLoginEnabled === true)
  }, [account])


  useEffect(() => {
    resetData()
  }, [onCancel])

  const handleCancel = (e) => {
    e.preventDefault()
    if (onCancel) {
      onCancel(e)
    }
  }

  const updateTwoFactorAuth = (e) => {
    e.preventDefault()
    const payload = { enabled: enable2FA, mfa_types: getMfaTypes() }
    enableMfa(account.id, payload, <Translate id='notifications.mfa.updated' data={{ name: <b>{account.name}</b> }} />).then(() => {
      updateDetails()
      handleCancel(e)
    })
  }

  return (
    <Form onSubmit={updateTwoFactorAuth} className={styles.twoFactorAuth}>
      <div className={styles.toggle2FA}>
        <h6 className={styles.heading}><Translate id='singleSignOn.toggle2FA' /></h6>
        <Switch
          offLabel={translate('common.form.buttons.off')}
          onChange={() => { setEnable2FA(prevState => !prevState) }}
          onLabel={translate('common.form.buttons.on')}
          size='default'
          checked={enable2FA}
        />
      </div>
      {enable2FA && <div className={styles.verificationMethod}>
        <h6 className={styles.heading}><Translate id='singleSignOn.verificationMethod' /></h6>
        <Radio
          description={translate('singleSignOn.mfaOption1Desc')}
          label={translate('singleSignOn.mfaOption1')}
          onChange={() => { setVerificationType(IVerificationType.EMAIL_AUTHENTICATOR_APP) }}
          size='default'
          value={IVerificationType.EMAIL_AUTHENTICATOR_APP}
          checked={verificationType === IVerificationType.EMAIL_AUTHENTICATOR_APP}
        />
        <Tooltip placement='right' autoAdjustOverflow title={cacDisabled && <Translate id='singleSignOn.cacDisabledNote' />}>
          <div>
            <Radio
              description={translate('singleSignOn.mfaOption2Desc')}
              label={translate('singleSignOn.mfaOption2')}
              onChange={() => { setVerificationType(IVerificationType.CAC) }}
              size='default'
              value={IVerificationType.CAC}
              checked={verificationType === IVerificationType.CAC}
              disabled={cacDisabled}
            />
          </div>
        </Tooltip>
      </div>}
      <div className={styles.formActions}>
        <Button buttonType={ButtonType.SECONDARY} onClick={handleCancel}>
          <Translate id='common.form.buttons.cancelBtn' />
        </Button>
        <SubmitButton>
          <Translate id='common.form.buttons.update2fa' />
        </SubmitButton>
      </div>
    </Form>
  )
}

export default connect(null, { enableMfa })(TwoFactorAuthentication)
